/**
 * @description: 轮播歌曲设置
 * @author: hwx
 */
<template>
    <div class="rotation-song-set">
        <div class="rs-list" v-show="showList">
            <div class="row row-margin">
                <button type="button" class="btn bg-orange btn-flat bigbtn" @click="add_rotation()">轮播歌曲设置</button>
            </div>
            <p>
                注：轮播歌曲设置成功后，需重启两次机顶盒生效。<br />
                禁毒轮播设置：轮播自定义歌曲-搜索歌名“禁毒宣传”-添加-保存<br />
                消防轮播设置：轮播自定义歌曲-搜索歌名“娱乐场所消防安全”-添加-保存
            </p>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="rs_list"></table>
            </div>
        </div>
        <!-- 设置 -->
        <div class="rs-set" v-show="showSet">
            <div class="page-tit">{{add_header}}</div>
            <div class="row">
                <label class="ctr-label-left">适用门店：</label>
                <div class="col-md-4 ct-col">
                    <select class="form-control" ref="rotation_shop" data-placeholder="请选择门店"></select>
                </div>
            </div>
            <div class="row">
                <label class="ctr-label-left">包厢号：</label>
                <div class="col-md-4">
                    <input class="form-control input-readonly" placeholder="请选择包厢号" v-model="rotation_room_num" ref="rotation_room_num" readonly @click="rotation_room_fun($event)">
                    <span class="selection-clear" @click="clearInput('rotation_room_num')">×</span>
                    <span class="span-arrow"><b></b></span>
                </div>
            </div>
            <div class="row">
                <label class="ctr-label-left">优先级：</label>
                <div class="col-md-4">
                    <input class="form-control" placeholder="请输入优先级" v-model="rs_listorder">
                </div>
                <span class="rmarkspan" titles="数值大的优先" @mouseenter="openPbHint($event)" @mouseleave="closePbHint"></span>
            </div>
            <div class="row">
                <label class="ctr-label-left">使用时间:</label>
                <div class="col-md-4">
                    <input class="form-control input-readonly" v-model="use_time_range" ref="use_time_range" placeholder="请选择使用时间" readonly @click="useTimePop()">
                    <span class="selection-clear" @click="clearInput('use_time_range')">×</span>
                    <span class="span-arrow"><b></b></span>
                </div>
            </div>
            <div class="row">
                <label class="ctr-label-left">有效星期日</label>
                <div class="col-md-4">
                    <input type="text" class="form-control input-readonly" placeholder="请选择有效星期日" v-model="week" ref="week" readonly @click="weekPop($event)">
                    <span class="selection-clear" @click="clearInput('week')">×</span>
                    <span class="span-arrow"><b></b></span>
                </div>
            </div>
            <div class="row rs-usedate">
                <label class="ctr-label-left">适用日期：</label>
                <div class="col-md-4">
                    <div class="time-wrapper" ref="rs_time_wrap">
                        <input type="text" class="form-control laydate-icon" v-model="rs_time_range" placeholder="请选择适用日期">
                    </div>
                </div>
            </div>
            <div class="row">
                <label class="ctr-label-left">离线默认轮播：</label>
                <div class="col-md-4 ct-col">
                    <select class="form-control" ref="rotation_default">
                        <option value="1">是</option>
                        <option value="-1">否</option>
                    </select>
                </div>
                <span class="rmarkspan" titles="离线默认轮播：当场所网络离线时场本地轮播歌曲默认播放的歌曲" @mouseenter="openPbHint($event)" @mouseleave="closePbHint"></span>
            </div>
            <div class="row">
                <label class="ctr-label-left">轮播歌曲类型：</label>
                <div class="col-md-4 ct-col">
                    <select class="form-control" data-placeholder="请选择轮播歌曲类型" ref="rotation_type">
                        <option value="1">轮播高清歌曲</option>
                        <option value="2">轮播排行歌曲</option>
                        <option value="3">轮播自定义歌曲</option>
                        <option value="4">轮播公视1</option>
                        <option value="5">轮播公视2</option>
                        <option value="6">轮播公视3</option>
                        <option value="7">主题歌单</option>
                    </select>
                </div>
            </div>
            <div class="rs-set-def row row-margin" v-show="showSong">
                <div class="row rowpadding">
                    <label class="ctr-label-left">自定义轮播歌曲</label>
                    <div class="col-md-4">
                        <input class="form-control input-readonly" placeholder="请选择自定义上传轮播歌曲" v-model="wake_song_name" ref="wake_song_name" readonly @click="wake_song_fun($event)" />
                        <span class="selection-clear" @click="clearInput('wake_song_fun')">×</span>
                        <span class="printer-arrow"><b></b></span>
                    </div>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="openWakeUpdsongs($event)">上传歌曲</button>
                </div>
                <label class="ctr-label-left">自定义歌曲：</label>
                <div class="col-md-5">
                    <h3>轮播自定义歌曲选择</h3>
                    <div class="row">
                        <div class="col-md-1 ct-col def-tit-sel">
                            <select class="form-control" ref="def_tit_sel">
                                <option value="szSong_name">歌曲名称</option>
                                <option value="szClass">歌曲分类</option>
                                <option value="szPlayer">歌手</option>
                            </select>
                        </div>
                        <div class="col-md-7 def-con-val">
                            <input type="text" class="form-control" v-model="def_con_val" :placeholder="def_con_phd">
                        </div>
                        <div class="pull-right">
                            <button type="button" class="btn btn-flat btn-small btn-orange" @click="querySong">查询</button>
                        </div>
                    </div>
                    <div class="table-responsive">
                        <table class="table table-bordered table-hover" data-pagination="true" ref="songList"></table>
                    </div>
                </div>
                <div class="col-md-5 pull-right">
                    <h3>轮播自定义歌曲列表</h3>
                    <p>注：1、最多可以选择40首轮播自定义歌曲<br>2、云库歌曲需在包厢机下载到本地才能播放<br>3、上传的歌曲仅支持轮播使用</p>
                    <div class="table-responsive">
                        <table class="table table-bordered table-hover" data-pagination="true" ref="songSelList">
                        </table>
                    </div>
                </div>
            </div>
            <div class="rs-set-def row row-margin" v-show="showTheme">
                <div class="row rowpadding">
                    <label class="ctr-label-left">主题歌单</label>
                    <div class="col-md-4">
                        <select class="form-control" ref="theme_song_name" @change="getThemeSongList" placeholder="请选择主题歌单" v-model="songs_type_id">
                            <option v-for="item in theme_song" :key="item.songs_type_id" :value="item.songs_type_id">{{item.songs_type_name}}</option>
                        </select>
                    </div>
                </div>
                <label class="ctr-label-left">主题歌单：</label>
                <div class="col-md-5">
                    <h3>主题歌单选择</h3>
                    <div class="row">
                        <div class="col-md-1 ct-col def-tit-sel">
                            <select class="form-control" ref="def_tit_sel">
                                <option value="szSong_name">歌曲名称</option>
                                <option value="szClass">歌曲分类</option>
                                <option value="szPlayer">歌手</option>
                            </select>
                        </div>
                        <div class="col-md-7 def-con-val">
                            <input type="text" class="form-control" v-model="def_con_val" :placeholder="def_con_phd">
                        </div>
                        <div class="pull-right">
                            <button type="button" class="btn btn-flat btn-small btn-orange" @click="queryThemeSong">查询</button>
                        </div>
                    </div>
                    <div class="table-responsive">
                        <table class="table table-bordered table-hover" data-pagination="true" ref="songThemeList"></table>
                    </div>
                </div>
            </div>
            
            <div class="row">
                <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backFun">返回</button>
                <button type="button" class="btn btn-flat btn-middle btn-orange sub-margin" @click="add_rotation_songs(addModify)">保存</button>
            </div>
        </div>
        <!-- 自定义上传轮播歌曲弹窗 -->
        <div class="srs-song-alert" ref="wakeSong_alert">
            <ul>
                <li v-for="item in songData" :key="item.id">
                    <input type="checkbox" v-model='w_song_checkModel' :value="item.id">
                    <label>{{item.text}}</label>
                    <img src="../../assets/images/icon_del.png" @click="delSong(item.id)">
                </li>
            </ul>
        </div>
        <!-- 上传歌曲 -->
        <div class="ele-hide" ref="wake_upload_songs">
            <div class="upload-wrap" id="uploadWrap">
                <span>选择并上传歌曲</span>
                <div class="upload-file-info" id="ossfileWake">
                    你的浏览器不支持flash,Silverlight或者HTML5！
                </div>
                <input type="button" value="选择文件" id="wakeSelFile">
                <button id="wakeSubFile">开始上传</button>
                <p>上传歌曲格式需为：<em>mkv/mp4/avi</em>，仅支持H.264编码的文件</p>
                <p>如上传格式不符合将无法正常播放</p>
                <p>歌曲分辨率不能超过1080p，单个文件大小不能超过200m。</p>
            </div>
        </div>
        <!-- 包厢号 -->
        <div class="multi-page" ref="box_area" v-show="showbox">
            <div class="page-tit">轮播歌曲包厢范围</div>
            <p>请选择轮播歌曲的包厢范围</p>
            <div class="multi-page-main">
                <div class="multi-page-row">
                    <div>
                        <input type="checkbox" v-model='room_all' @click='roomAllcheck'>
                        <span>全部</span>
                    </div>
                    <ul></ul>
                </div>
                <div class="multi-page-row" v-for="(items, index) in room_checkboxdata">
                    <div>
                        <input type="checkbox" v-model='room_flrModel' :value="items.room_area" @click="roomFlr(items.room_area, index)">
                        <span>{{items.room_area_name}}</span>
                    </div>
                    <ul class="clearfix">
                        <li v-for="item in items.room">
                            <input type="checkbox" v-model='room_checkboxModel' :value="item.id">
                            <span>{{item.name}}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="row">
                <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="roomboxbackFun()">返回</button>
                <button type="button" class="btn btn-flat btn-middle btn-orange sub-margin" @click="roomboxokFun()">确定</button>
            </div>
        </div>
        <!-- 使用时间弹窗 -->
        <div class="use-time-wrap" ref="rs_use_time">
            <h2>开始时间：</h2>
            <select ref="starthour"></select>
            <label class="colon">:</label>
            <select ref="startseconds"></select>
            <h2>结束时间：</h2>
            <select ref="stophour" id="stophour"></select>
            <label class="colon">:</label>
            <select ref="stopseconds"></select>
        </div>
        <!--星期选择弹窗-->
        <div class="ele-hide" ref="week_popup">
            <div class="multi-select">
                <div class="clearfix">
                    <input type='checkbox' v-model='week_allcheck' @click='weekCheckedAll'>
                    <label>全选</label>
                </div>
                <ul class="clearfix">
                    <li>
                        <input type="checkbox" v-model='week_checkboxModel' value="1">
                        <label>星期一</label>
                    </li>
                    <li>
                        <input type="checkbox" v-model='week_checkboxModel' value="2">
                        <label>星期二</label>
                    </li>
                    <li>
                        <input type="checkbox" v-model='week_checkboxModel' value="3">
                        <label>星期三</label>
                    </li>
                    <li>
                        <input type="checkbox" v-model='week_checkboxModel' value="4">
                        <label>星期四</label>
                    </li>
                    <li>
                        <input type="checkbox" v-model='week_checkboxModel' value="5">
                        <label>星期五</label>
                    </li>
                    <li>
                        <input type="checkbox" v-model='week_checkboxModel' value="6">
                        <label>星期六</label>
                    </li>
                    <li>
                        <input type="checkbox" v-model='week_checkboxModel' value="0">
                        <label>星期日</label>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
        export default {
        name: 'rotation-song-set',
        data() {
            return {
                showList: true,
                showSet: false,
                showbox: false,
                showSong: false,
                showTheme: false,
                addModify: 1,

                rotation_room_num: "",
                room_all: false,
                c_room_all: false,
                room_flrModel: [],
                c_room_flrModel: [],
                room_checkboxdata:[],
                room_checkboxModel:[],
                c_room_checkboxModel: [],
                room_detailcheckboxdata:[],
                def_field: 'szSong_name',
                def_con_phd: "请输入歌曲名称",
                def_con_val: '',
                selSongData: [],
                add_header: '轮播歌曲设置',
                detailData: {
                    type: Object
                },
                rs_listorder: '',
                time_start_time: '',
                time_end_time: '',
                week: '',
                week_allcheck: false,
                c_week_allcheck: false,
                week_checkboxModel: [],
                week_checkboxData: [{id: "1", name: "一"}, {id: "2", name: "二"}, {id: "3", name: "三"}, {id: "4", name: "四"}, {id: "5", name: "五"}, {id: "6", name: "六"}, {id: "0", name: "日"}],
                rs_use_every_day: -1,
                rs_time_range: '',
                rs_time_start: '',
                rs_time_end: '',
                songs_type_id: '',

                wake_song_name: '',
                w_song_checkModel: [],
                songData: [],

                theme_song: [],
                theme_song_list: [],
            }
        },
        computed: {
            use_time_range() {
                return this.time_start_time + "-" + this.time_end_time;
            }
        },
        watch: {
            rotation_room_num: {
                handler: function(val, oldval) {
                    if(val != "") {
                        $(this.$refs.rotation_room_num).parent().find('.selection-clear').show();
                    } else {
                        $(this.$refs.rotation_room_num).parent().find('.selection-clear').hide();
                        // this.room_checkboxModel = [];
                    }
                },
                deep: true
            },
            room_checkboxModel: {
                handler: function(val, oldVal) {
                    let _this = this;

                    if(_this.room_checkboxModel.length >= _this.room_detailcheckboxdata.length) {
                        _this.room_all = true;
                        _this.c_room_all = _this.room_all;
                    } else {
                        _this.room_all = false;
                        _this.c_room_all = _this.room_all;
                    }

                    $.each(_this.room_checkboxdata, function(k, v) {
                        if(_this.room_checkboxModel.length >= v.room.length) {
                            let num = 0;
                            for(let i = 0, len = v.room.length; i < len; i++) {
                                if(_this.room_checkboxModel.indexOf(v.room[i].id) != -1) {
                                    num++;
                                }
                                if(i == v.room.length - 1 && num == v.room.length) {
                                    if(_this.room_flrModel.indexOf(v.room_area) == -1) {
                                        _this.room_flrModel.push(v.room_area);
                                    }
                                } else {
                                    let index = '';
                                    index = _this.room_flrModel.indexOf(v.room_area);
                                    if(index != -1) {
                                        _this.room_flrModel.splice(index, 1);
                                    }
                                }
                            }
                        } else {
                            let index = '';
                            index = _this.room_flrModel.indexOf(v.room_area);
                            if(index != -1) {
                                _this.room_flrModel.splice(index, 1);
                            }
                        }
                    });
                    _this.c_room_flrModel = _this.room_flrModel;
                },
                deep: true
            },

            use_time_range: {
                handler: function(val, oldval) {
                    if(val != "-") {
                        $(this.$refs.use_time_range).parent().find('.selection-clear').show();
                    } else {
                        $(this.$refs.use_time_range).parent().find('.selection-clear').hide();
                    }
                },
                deep: true
            },

            week: {
                handler: function(val, oldval) {
                    if(val != ""){
                        $(this.$refs.week).parent().find('.selection-clear').show();
                    } else {
                        $(this.$refs.week).parent().find('.selection-clear').hide();
                    }
                },
                deep: true
            },
            week_checkboxModel: {
                handler: function (val, oldVal) {
                    if(this.week_checkboxModel.length >= this.week_checkboxData.length) {
                        this.week_allcheck = true;
                        this.c_week_allcheck = true;
                    } else {
                        this.week_allcheck = false;
                        this.c_week_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            let _this = this;
            _this.$nextTick(function() {
                _this.initTable();
                _this.getshopdata();
                $(_this.$refs.rotation_default).select2({
                    minimumResultsForSearch: -1,
                    language: "zh-CN",
                    width: '100%'
                });
                $(_this.$refs.rotation_type).select2({
                    minimumResultsForSearch: -1,
                    language: "zh-CN",
                    width: '100%',
                    templateSelection: function(val) {
                        if(val.text == '轮播自定义歌曲') {
                            _this.showSong = true;
                            _this.showTheme = false;
                            _this.innitSongTable();
                            _this.innitSongSelTable();
                            _this.getSongsData();
                        } else if(val.text == '主题歌单') {
                            _this.showSong = false;
                            _this.showTheme = true;
                            _this.getThemeSong();
                            if(_this.songs_type_id != '') {
                                _this.innitSongThemeTable();
                            }
                            // 重置查询条件
                            $(_this.$refs.def_tit_sel).val('szSong_name').trigger('change');
                            _this.def_field = 'szSong_name';
                            _this.def_con_phd = '请输入歌曲名称';
                            _this.def_con_val = '';
                        } else {
                            _this.showSong = false;
                            _this.showTheme = false;
                            $(_this.$refs.def_tit_sel).val('').trigger('change');
                            _this.selSongData = [];
                        }
                        return val.text
                    }
                });
                _this.selectTime();
                _this.initRsTime();
                // 下拉选项
                $(_this.$refs.def_tit_sel).select2({
                    language: "zh-CN",
                    minimumResultsForSearch: -1,
                    width: '100%'
                }).change(function() {
                    _this.def_field = $(this).val();
                    _this.def_con_val = '';
                    if(_this.def_field == 'szSong_name') {
                        _this.def_con_phd = '请输入歌曲名称';
                    } else if(_this.def_field == 'szClass') {
                        _this.def_con_phd = '请输入歌曲分类';
                    } else if(_this.def_field == 'szPlayer') {
                        _this.def_con_phd = '请输入歌手';
                    }
                });

                // 上传自定义歌曲
                this.uploadNewSongWake();
            });
        },
        methods: {
            // 页面提示语
            openPbHint: function(e) {
                let contents = "<span class='dots'>·</span>" + $(e.currentTarget).attr("titles");
                layer.tips(contents, (e.currentTarget), {
                    skin: 'hint_language_tip',
                    tips: [2, '#fff'],
                    time: 2000000,
                });
            },
            // 关闭提示语
            closePbHint: function() {
                layer.closeAll('tips');
            },
            // 日期范围
            initRsTime: function() {
                let _this = this;
                $(_this.$refs.rs_time_wrap).daterangepicker({
					parentEl: '.rs-usedate',
                    drops: 'up',
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray'
                }, function(start, end, label) {
                    _this.rs_time_start = start.format('YYYY-MM-DD');
                    _this.rs_time_end = end.format('YYYY-MM-DD');
                    if($(".rs-usedate-everyday input").val() == "1") {
						_this.rs_time_range = '每天';
						_this.rs_use_every_day = '1';
						return;
					} else {
						_this.rs_time_range = start.format('YYYY-MM-DD') + ' ~ ' + end.format('YYYY-MM-DD');
						_this.rs_use_every_day = '-1';
					}
                });

                $(".rs-usedate .daterangepicker:last").find(".ranges").prepend(
					'<div class="rs-usedate-everyday">' +
						'<input type="checkbox" />' +
						'<label>每天</label>' +
					'</div>'
				);
				$(".rs-usedate-everyday input").click(function() {
					if($(this).val() == "1") {
						$(this).prop("checked", false);
						$(this).val('');
					} else {
						$(this).prop("checked", true);
						$(this).val('1');
					}
				});
            },
            initTable: function() {
                let _this = this;
                $(_this.$refs.rs_list).bootstrapTable('destroy');
                $(_this.$refs.rs_list).bootstrapTable({
                    pageSize: 10,
                    ajax: function(params) {
                        _this.getMolingList(params);
                    },
                    sidePagination: "server",
                    pagination: true,
                    columns: [{
                        width: "8%",
                        field: "listorder",
                        title: "优先级"
                    }, {
                        width: "11%",
                        field: "shop_name",
                        title: "门店"
                    }, {
                        width: "13%",
                        field: "room_name",
                        title: "包厢"
                    }, {
                        width: "11%",
                        field: "type_name",
                        title: "轮播歌曲类型"
                    }, {
                        width: "11%",
                        field: "start_time",
                        title: "使用时间",
                        formatter: function(value, row, index) {
                            return value + '-' + row.end_time;
                        }
                    }, {
                        width: "11%",
                        field: "default",
                        title: "离线默认轮播",
                        formatter: function(value, row, index) {
                            if(value == '1') {
                                return '是';
                            } else {
                                return '否';
                            }
                        }
                    }, {
                        width: "11%",
                        field: "week_cycle_info",
                        title: "有效星期日"
                    }, {
                        width: "11%",
                        field: "use_time",
                        title: "适用日期"
                    }, {
                        width: "11%",
                        field: "update_time",
                        title: "操作时间"
                    }, {
                        width: "11%",
                        title: "操作",
                        events: {
                            'click .modify': function(e, value, row) {
                                _this.addModify = 2;
                                _this.add_header = '修改轮播歌曲';
                                _this.getSongDetail(row.id);
                                _this.showSet = true;
                                _this.showList = false;
                            },
                            'click .delete': function(e, value, row) {
                                //debugger;
                                layer.confirm('删除后不可恢复，确定删除吗？', {
                                    btn: ['确定', '取消'] //按钮
                                }, function() {
                                    _this.deleteSong(row.id);
                                });
                            }
                        },
                        formatter: function(value, row, index) {
                            return '<span class="text-blue modify">修改</span>&nbsp;&nbsp;<span class="text-blue delete">删除</span>'
                        }
                    }]
                });
            },
            // 获取轮播歌曲列表
            getMolingList: function(params) {
                let _this = this;
                let pageNumber = 1;
                if (params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "setting/getRollingList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            params.success({
                                total: data['response']['result']['total'],
                                rows: data['response']['result']['rows']
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data["response"]["error_msg"]);
                            params.success({
                                total: 0,
                                rows: []
                            });
                        }
                    },
                    error: function(err) {
                        layer.close("出错啦");
                    }
                });
            },
            // 点击‘轮播歌曲设置’
            add_rotation: function() {
                let _this = this;
                this.addModify = 1;
                this.add_header = '新增轮播歌曲';
                $(this.$refs.rotation_shop).prop("disabled", false);
                $(this.$refs.rotation_shop).val('').trigger('change');
                // 包厢号
                // this.getAllRoomByArea($(this.$refs.rotation_shop).val());
                $(this.$refs.rotation_room_num).parent().find('.selection-clear').show();
                $(this.$refs.rotation_room_num).prop("disabled", true);
                this.rotation_room_num = '全部';
                this.room_checkboxModel = [];
                this.room_detailcheckboxdata.forEach(function(item) {
                    _this.room_checkboxModel.push(item.id);
                });
                this.rs_listorder = '';
                this.time_start_time = '';
                this.time_end_time = '';
                this.week = "";
                this.week_checkboxModel = [];
                this.rs_time_start = '';
                this.rs_time_end = '';
                _this.rs_time_range = '';
				_this.rs_use_every_day = -1;
				$(".rs-usedate-everyday input").val("");
				$(".rs-usedate-everyday input").prop("checked", false);

                $(this.$refs.rotation_default).val('').trigger('change');
                $(this.$refs.rotation_type).val('').trigger('change');
                this.showSong = false;
                this.selSongData = [];
                this.songs_type_id = '';
                this.showTheme = false;
                this.songThemeList = [];

                this.showSet = true;
                this.showList = false;
            },
            // 门店数据
            getshopdata: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {}
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            let arr = [];
                            $.each(data['response']['result'], function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            // arr.shift();
                            $(_this.$refs.rotation_shop).select2({
                                data: arr,
                                minimumResultsForSearch: -1,
                                language: "zh-CN",
                                width: '100%'
                            }).on("select2:select", function(e) {
                                if(e.params.data.id != 0){
                                    _this.getAllRoomByArea(e.params.data.id);
                                // 包厢号默认全选
                                _this.rotation_room_num = '全部';
                                _this.room_checkboxModel = [];
                                _this.room_detailcheckboxdata.forEach(function(item) {
                                    _this.room_checkboxModel.push(item.id);
                                });
                                $(_this.$refs.rotation_room_num).prop("disabled", false);
                                }else{
                                    _this.rotation_room_num = '全部';
                                    // 禁用
                                    $(_this.$refs.rotation_room_num).prop("disabled", true);
                                }

                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {
                        layer.msg('出错啦');
                    }
                });
            },
            // 点击选择包厢号
            rotation_room_fun: function(e) {
                let _this = this;
                _this.c_room_checkboxModel = _this.room_checkboxModel;
                _this.c_room_all = _this.room_all;

                _this.showSet = false;
                _this.showbox = true;
            },
            // 包厢号数据
            getAllRoomByArea: function(shopid) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shopid || ""
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getAllRoomByArea",
                    async: false,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            _this.room_checkboxdata = data['response']['result'];
                            let newarray = [];
                            $.each(data['response']['result'], function(k, v) {
                                $.each(v.room, function(m, n) {
                                    newarray.push(n);
                                });
                            });
                            _this.room_detailcheckboxdata = newarray;
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {
                        layer.msg('出错啦');
                    }
                });
            },
            // 全选
            roomAllcheck: function() {
                let _this = this;
                _this.room_all = _this.c_room_all;
                if(!_this.room_all) { // 实现全选
                    _this.room_checkboxModel = [];
                    _this.room_detailcheckboxdata.forEach(function(item) {
                        _this.room_checkboxModel.push(item.id);
                    });
                } else { // 实现反选
                    _this.room_checkboxModel = [];
                }
            },
            // 楼层全选/反选
            roomFlr: function(id, index) {
                let _this = this;
                _this.room_flrModel = _this.c_room_flrModel;
                if(_this.room_flrModel.indexOf(id) == -1) {
                    $.each(_this.room_checkboxdata[index].room, function(k, v) {
                        if(_this.room_checkboxModel.indexOf(v.id) == -1) {
                            _this.room_checkboxModel.push(v.id);
                        }
                    });
                } else {
                    $.each(_this.room_checkboxdata[index].room, function(k, v) {
                        let index = '';
                        index = _this.room_checkboxModel.indexOf(v.id);
                        if(index != -1) {
                            _this.room_checkboxModel.splice(index, 1);
                        }
                    });
                }
            },
            // 确定包厢
            roomboxokFun: function() {
                let _this = this;
                let texts = [];
                if(_this.room_checkboxModel.length >= _this.room_detailcheckboxdata.length) {
                    _this.rotation_room_num = '全部';
                } else {
                    _this.room_detailcheckboxdata.forEach(function(item) {
                        _this.room_checkboxModel.forEach(function(item2) {
                            if(item.id == item2) {
                                texts.push(item.name);
                            }
                        });
                    });
                    _this.rotation_room_num = texts.join(",");
                }
                _this.showSet = true;
                _this.showbox = false;
            },
            // 返回
            roomboxbackFun: function() {
                this.showSet = true;
                this.showbox = false;
            },
            // 清空包厢号
            clearInput: function(name) {
                if(name == "rotation_room_num") {
                    this.rotation_room_num = '';
                    this.room_checkboxModel = [];
                } else if(name == "use_time_range") {
                    this.time_start_time = '';
                    this.time_end_time = '';
                } else if(name == "week") {
                    this.week = "";
                    this.week_checkboxModel = [];
                }
            },
            // 初始化歌曲选择列表
            innitSongTable: function() {
                let _this = this;
                $(_this.$refs.songList).bootstrapTable('destroy');
                $(_this.$refs.songList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getSongList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "szSong_name",
                        title: "歌曲名称",
                        width: "23%"
                    }, {
                        field: "szClass",
                        title: "歌曲分类",
                        width: "20%"
                    }, {
                        field: "szPlayer",
                        title: "歌手",
                        width: "19%"
                    }, {
                        field: "songs_version",
                        title: "版本",
                        width: "19%"
                    }, {
                        title: "操作",
                        width: "19%",
                        events: {
                            'click .add': function(e, value, row) {
                                if(_this.selSongData.length >= 40) {
                                    layer.msg("最多选择40首轮播自定义歌曲");
                                    return;
                                }
                                _this.selSongData.push(row);
                                _this.innitSongSelTable();
                            }
                        },
                        formatter: function(value, row, index) {
                            return '<span class="text-blue add">添加</span>'
                        }
                    }],
                });
            },
            // 获取歌曲列表
            getSongList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let name = '',
                    szClass = '',
                    szPlayer = '';
                if(_this.def_field == 'szSong_name') {
                    name = _this.def_con_val;
                } else if(_this.def_field == 'szClass') {
                    szClass = _this.def_con_val;
                } else if(_this.def_field == 'szPlayer') {
                    szPlayer = _this.def_con_val;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "name": name,
                            "szClass": szClass,
                            "szPlayer": szPlayer
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getSongsList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.data.total,
                                rows: data.response.data.rows
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 初始化已选歌曲列表
            innitSongSelTable: function() {
                let _this = this;
                $(_this.$refs.songSelList).bootstrapTable('destroy');
                $(_this.$refs.songSelList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    columns: [{
                        field: "szSong_name",
                        title: "歌曲名称",
                        width: "23%"
                    }, {
                        field: "szClass",
                        title: "歌曲分类",
                        width: "20%"
                    }, {
                        field: "szPlayer",
                        title: "歌手",
                        width: "19%"
                    }, {
                        field: "songs_version",
                        title: "版本",
                        width: "19%"
                    }, {
                        title: "操作",
                        width: "19%",
                        events: {
                            'click .del': function(e, value, row, index) {
                                _this.selSongData.splice(index, 1);
                                _this.innitSongSelTable();
                            }
                        },
                        formatter: function(value, row, index) {
                            return '<span class="text-blue del">删除</span>'
                        }
                    }],
                    data: _this.selSongData
                });
            },
            // 点击“查询”歌曲
            querySong: function() {
                $(this.$refs.songList).bootstrapTable("destroy");
                this.innitSongTable();
            },
            // 点击"查询"主题歌单歌曲
            queryThemeSong: function() {
                $(this.$refs.songThemeList).bootstrapTable("destroy");
                this.innitSongThemeTable();
            },
            // 添加、修改
            add_rotation_songs: function(addModify) {
                let _this = this;

                let room_id = ['all'];
                if(_this.rotation_room_num == '') {
                    layer.msg('包厢号不能为空');
                    return;
                } else if(_this.rotation_room_num != '全部') {
                    room_id = _this.room_checkboxModel;
                }
                
                // 如果选择主题歌单但未选择具体歌单，提示用户
                if($(_this.$refs.rotation_type).val() == '7' && (!_this.songs_type_id || _this.songs_type_id == '')) {
                    layer.msg('请选择主题歌单');
                    return;
                }
                let url = Vue.ctUrl + "Setting/setRolling";
                let params = {
                    "shop_id": $(_this.$refs.rotation_shop).val(),
                    "room_id": room_id,
                    "default": $(_this.$refs.rotation_default).val(),
                    "type": $(_this.$refs.rotation_type).val(),
                    "songs": _this.selSongData,
                    "listorder": _this.rs_listorder,
                    "start_time": _this.time_start_time,
                    "end_time": _this.time_end_time,
                    "week_cycle": _this.week_checkboxModel,
                    "use_every_day": _this.rs_use_every_day,
                    "use_start_time": _this.rs_time_start,
                    "use_end_time": _this.rs_time_end
                };
                
                // 如果选择的是主题歌单，添加songs_type_id参数
                if($(_this.$refs.rotation_type).val() == '7') {
                    params.songs_type_id = _this.songs_type_id;
                }
                
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": params
                    },
                    "comment": ""
                };
                if(addModify == "2") {
                    url = Vue.ctUrl + "Setting/updateRolling";
                    datas.request.param.id = _this.detailData.id;
                    // 修改操作时，如果是主题歌单，确保传递songs_type_id
                    if($(_this.$refs.rotation_type).val() == '7') {
                        datas.request.param.songs_type_id = _this.songs_type_id;
                    }
                }
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: url,
                    async: true,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            layer.msg(data["response"]["error_msg"]);

                            _this.initTable();
                            _this.showSet = false;
                            _this.showList = true;
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {

                    }
                });
            },
            // 删除
            deleteSong: function(id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "id": id
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "Setting/delRolling",
                    async: true,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            layer.msg(data["response"]["error_msg"]);

                            _this.initTable();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {

                    }
                });
            },
            // 详情数据
            getSongDetail: function(id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "id": id
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "Setting/getRollingDetail",
                    async: true,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            _this.detailData = data.response.result;
                            // 门店
                            $(_this.$refs.rotation_shop).prop("disabled", true);
                            $(_this.$refs.rotation_shop).val(_this.detailData.shop_id).trigger("change");
                            // 包厢号
                            $(_this.$refs.rotation_room_num).parent().find('.selection-clear').hide();
                            $(_this.$refs.rotation_room_num).prop("disabled", true);
                            _this.rotation_room_num = _this.detailData.room_name;
                            if($(_this.$refs.rotation_shop).val() != '0') { // 非全部门店
                                _this.getAllRoomByArea($(_this.$refs.rotation_shop).val());
                            }
                            if(_this.rotation_room_num != '全部') {
                                _this.room_checkboxModel = _this.detailData.room_id;
                            } else {
                                _this.room_checkboxModel = [];
                                _this.room_detailcheckboxdata.forEach(function(item) {
                                    _this.room_checkboxModel.push(item.id);
                                });
                            }

                            _this.rs_listorder = _this.detailData.listorder;
                            // 使用时间
                            _this.time_start_time = _this.detailData.start_time;
                            _this.time_end_time = _this.detailData.end_time;
                            _this.week = _this.detailData.week_cycle_info;
                            _this.week_checkboxModel = _this.detailData.week_cycle;
                            if(_this.detailData.use_every_day == '1') {
                                _this.rs_time_start = '';
                                _this.rs_time_end = '';
                                _this.rs_time_range = '每天';
                                _this.rs_use_every_day = _this.detailData.use_every_day;
                                $(".rs-usedate-everyday input").val("1");
                                $(".rs-usedate-everyday input").prop("checked", true);
                            } else {
                                _this.rs_time_start = _this.detailData.use_start_time;
                                _this.rs_time_end = _this.detailData.use_end_time;
                                _this.rs_time_range = _this.detailData.use_start_time + '~' + _this.detailData.use_end_time;
                                _this.rs_use_every_day = _this.detailData.use_every_day;
                                $(".rs-usedate-everyday input").val("");
                                $(".rs-usedate-everyday input").prop("checked", false);
                            }
                            $(_this.$refs.rotation_default).val(_this.detailData.default).trigger('change');
                            // 轮播歌曲类型
                            $(_this.$refs.rotation_type).val(_this.detailData.type).trigger('change');
                            if(_this.detailData.type == 3) {
                                _this.showSong = true;
                                _this.selSongData = _this.detailData.songs;
                                _this.innitSongSelTable();
                            } else if(_this.detailData.type == 7) {
                                _this.showTheme = true;
                                _this.songs_type_id = _this.detailData.songs_type_id;
                                _this.innitSongThemeTable();
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {

                    }
                });
            },
            // 返回
            backFun: function() {
                this.showList = true;
                this.showSet = false;
            },
            // 点击选择时间
            useTimePop: function() {
                let _this = this;
                if(_this.time_start_time != '') {
                    $(_this.$refs.starthour).val(_this.time_start_time.split(':')[0]).trigger('change');
                    $(_this.$refs.startseconds).val(_this.time_start_time.split(':')[1]).trigger('change');
                    $(_this.$refs.stophour).val(_this.time_end_time.split(':')[0]).trigger('change');
                    $(_this.$refs.stopseconds).val(_this.time_end_time.split(':')[1]).trigger('change');
                }
                layer.confirm('', {
                    type: 1,
                    skin: 'public-alert-skin', // 加上边框
                    btn: ['确定', '取消'], // 按钮
                    title: '使用时间选择',
                    area: ['450px', ''], // 宽高
                    content: $(_this.$refs.rs_use_time)
                }, function() {
                    _this.createTimeString();
                    layer.closeAll();
                });
            },
            // 获取选择的时间
            createTimeString() {
                let _this = this;
                let starthour = $(_this.$refs.starthour).select2("val");
                let startseconds = $(_this.$refs.startseconds).select2("val");
                let stophour = $(_this.$refs.stophour).select2("val");
                let stopseconds = $(_this.$refs.stopseconds).select2("val");
                _this.time_start_time = starthour + ":" + startseconds;
                _this.time_end_time = stophour + ":" + stopseconds;
            },
            // 获取时间
            selectTime: function() {
                let _this = this;
                let seconds = [];
                for(let i = 0; i < 60; i++) {
                    let item = {};
                    item.id = (i < 10) ? '0' + i : i;
                    item.text = (i < 10) ? '0' + i : i;
                    seconds[i] = item;
                };
                let hour = [];
                for(let i = 0; i < 24; i++) {
                    let item = {};
                    item.id = (i < 10) ? '0' + i : i;
                    item.text = (i < 10) ? '0' + i : i;
                    hour[i] = item;
                }
                $(_this.$refs.starthour).select2({
                    data: hour,
                    language: "zh-CN",
                    width: 'auto'
                });
                $(_this.$refs.startseconds).select2({
                    data: seconds,
                    language: "zh-CN",
                    width: 'auto'
                });
                $(_this.$refs.stophour).select2({
                    data: hour,
                    language: "zh-CN",
                    width: 'auto'
                });
                $(_this.$refs.stopseconds).select2({
                    data: seconds,
                    language: "zh-CN",
                    width: 'auto'
                });
            },

            // 获取选中的星期日
            weekPop: function() {
                let _this = this;
                let c_week_checkboxModel = _this.week_checkboxModel;
                layer.confirm('', {
                    type: 1,
                    skin: 'public-alert-skin',
                    btn: ['确定', '取消'], // 按钮
                    title: ['有效星期日', true],
                    area: ['450px', ''], // 宽高
                    content: $(_this.$refs.week_popup),
                    cancel: function() {
                        // 右上角关闭
                        if(_this.week != "") {
                            _this.week_checkboxModel = c_week_checkboxModel;
                            return;
                        }
                        _this.week_checkboxModel = [];
                    }
                }, function() {
                    let texts = [];
                    _this.week_checkboxData.forEach(function(item) {
                        _this.week_checkboxModel.forEach(function(item2) {
                            if(item.id == item2){
                                texts.push(item.name);
                            }
                        });
                    });
                    _this.week = texts.join(",");
                    layer.closeAll();
                }, function() {
                    if(_this.week != "") {
                        _this.week_checkboxModel = c_week_checkboxModel;
                        return;
                    }
                    _this.week_checkboxModel = [];
                });
            },
            // 全选
            weekCheckedAll: function() {
                var _this = this;
                _this.week_allcheck = _this.c_week_allcheck;
                if(!_this.week_allcheck) { // 实现全选
                    _this.week_checkboxModel = [];
                    _this.week_checkboxData.forEach(function(item) {
                        _this.week_checkboxModel.push(item.id);
                    });
                } else { // 实现反选
                    _this.week_checkboxModel = [];
                }
            },

            // 点击上传歌曲
            openWakeUpdsongs: function(e) {
                let _this = this;
                layer.confirm('', {
                    skin: 'add_printer_area upload-songs',
                    type: 1,
                    btn: ['选择文件'], // 按钮
                    title: ['上传歌曲', true],
                    area: ['650px', '500px'], // 宽高
                    content: $(_this.$refs.wake_upload_songs),
                    cancel: function() {
                        // 右上角关闭
                        document.getElementById('ossfileWake').innerHTML = '';
                    }
                });
            },
            // 上传自定义歌曲
            uploadNewSongWake: function() {
                var _this = this;
                var accessid = '',
                    accesskey = '',
                    host = '',
                    policyBase64 = '',
                    signature = '',
                    callbackbody = '',
                    filename = '',
                    key = '',
                    expire = 0,
                    g_object_name = '',
                    g_object_name_type = 'local_name',  // 上传文件名字保持本地文件名字
                    now = Date.parse(new Date()) / 1000;
                var body = '';
                function send_request() {
                    var xmlhttp = null;
                    if(window.XMLHttpRequest) {
                        xmlhttp = new XMLHttpRequest();
                    } else if(window.ActiveXObject) {
                        xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
                    }
                    if(xmlhttp != null) {
                        let datas = {
                            "header": Vue.request_header,
                            "request": {
                                "param": {
                                    // 'file': filename
                                }
                            },
                            "comment": ""
                        };
                        datas = JSON.stringify(datas);
                        $.ajax({
                            type: "POST",
                            dataType: "json",
                            url: Vue.ctUrl + "Setting/getOssSignature",
                            async: false,
                            crossDomain: true,
                            xhrFields: {
                                withCredentials: true
                            },
                            data: datas,
                            success: function(data) {
                                if(data['response']['result_code'] == "true") {
                                    body = data.response.result.signature;
                                } else {
                                    Vue.timeoutfun(data.response.result_status, _this);
                                    layer.msg(data["response"]["error_msg"]);
                                }
                            },
                            error: function(err) {
                                layer.msg('出错啦');
                            }
                        });
                    } else {
                        alert("Your browser does not support XMLHTTP.");
                    }
                };
                function get_signature() {
                    // 可以判断当前expire是否超过了当前时间,如果超过了当前时间,就重新取一下.3s 做为缓冲
                    now = Date.parse(new Date()) / 1000;
                    if(expire < now + 3) {
                        send_request();  // 返回签名
                        var obj = body;
                        host = obj['host'];
                        policyBase64 = obj['policy'];
                        accessid = obj['accessid'];
                        signature = obj['signature'];
                        expire = parseInt(obj['expire']);
                        callbackbody = obj['callback'];
                        key = obj['dir'];
                        return true;
                    }
                    return false;
                };
                function get_uploaded_object_name(filename) {
                    let tmp_name = key + g_object_name
                    tmp_name = tmp_name.replace("${filename}", filename);
                    return tmp_name
                }
                function set_upload_param(up, filename, ret) {
                    if(ret == false) {
                        ret = get_signature();
                    }
                    let new_multipart_params = {
                        'key': key + g_object_name,
                        'policy': policyBase64,
                        'OSSAccessKeyId': accessid, 
                        'success_action_status' : '200', // 让服务端返回200,不然，默认会返回204
                        'callback' : callbackbody,
                        'signature': signature,
                    };
                    up.setOption({
                        'url': host,
                        'multipart_params': new_multipart_params
                    });
                    up.start();
                }
                function getFileName(filename) {
                    let datas = {
                        "header": Vue.request_header,
                        "request": {
                            "param": {
                                'file': filename
                            }
                        },
                        "comment": ""
                    };
                    datas = JSON.stringify(datas);
                    $.ajax({
                        type: "POST",
                        dataType: "json",
                        url: Vue.ctUrl + "Setting/getFileName",
                        async: false,
                        crossDomain: true,
                        xhrFields: {
                            withCredentials: true
                        },
                        data: datas,
                        success: function(data) {
                            if(data['response']['result_code'] == "true") {
                                g_object_name = data.response.result.file_name;
                            } else {
                                Vue.timeoutfun(data.response.result_status, _this);
                                layer.msg(data["response"]["error_msg"]);
                            }
                        },
                        error: function(err) {
                            layer.msg('出错啦');
                        }
                    });
                }
                var uploader = new plupload.Uploader({
                    runtimes : 'html5,flash,silverlight,html4',
                    browse_button : 'wakeSelFile',
                    container: document.getElementById('uploadWrap'),
                    flash_swf_url : 'lib/plupload-2.1.2/js/Moxie.swf',
                    silverlight_xap_url : 'lib/plupload-2.1.2/js/Moxie.xap',
                    url : Vue.ctUrl + "Setting/saveCustomSongsInfo",
                    filters: {
                        mime_types : [ // 只允许上传mkv, mp4, avi文件
                            { title : "Video files", extensions: "mkv,mp4,avi" }
                        ],
                        max_file_size : '200mb', // 最大只能上传200mb的文件
                        prevent_duplicates : true // 不允许选取重复文件
                    },
                    init: {
                        PostInit: function() {
                            document.getElementById('ossfileWake').innerHTML = '';
                            document.getElementById('wakeSubFile').onclick = function() {
                                set_upload_param(uploader, '', false);
                                return false;
                            };
                        },
                        FilesAdded: function(up, files) {
                            plupload.each(files, function(file) {
                                document.getElementById('ossfileWake').innerHTML += '<div id="' + file.id + '"><span>' + file.name + '</span> (' + plupload.formatSize(file.size) + ')<b></b>'
                                +'<div class="progress"><div class="progress-bar" style="width: 0%"></div></div>'
                                +'</div>';
                            });
                        },
                        BeforeUpload: function(up, file) {
                            getFileName(file.name);
                            set_upload_param(up, '', true);
                        },
                        UploadProgress: function(up, file) {
                            var d = document.getElementById(file.id);
                            d.getElementsByTagName('b')[0].innerHTML = '<span>' + file.percent + "%</span>";
                            var prog = d.getElementsByTagName('div')[0];
                            var progBar = prog.getElementsByTagName('div')[0]
                            progBar.style.width= 5 * file.percent + 'px';
                            progBar.setAttribute('aria-valuenow', file.percent);
                        },
                        FileUploaded: function(up, file, info) {
                            if(info.status == 200) {
                                let finalPath = get_uploaded_object_name(file.name);
                                // 保存上传的文件信息
                                let datas = {
                                    "header": Vue.request_header,
                                    "request": {
                                        "param": {
                                            "type": 2,
                                            "song_down_file": finalPath, // 文件存储路径
                                            "song_name": g_object_name // 文件名
                                        }
                                    },
                                    "comment": ""
                                };
                                datas = JSON.stringify(datas);
                                $.ajax({
                                    type: "POST",
                                    dataType: "json",
                                    url: Vue.ctUrl + "Setting/saveCustomSongsInfo",
                                    async: true,
                                    crossDomain: true,
                                    xhrFields: {
                                        withCredentials: true
                                    },
                                    data: datas,
                                    success: function(data) {
                                        if(data['response']['result_code'] == "true") {
                                            layer.msg('上传成功');
                                            _this.getSongsData();
                                        } else {
                                            Vue.timeoutfun(data.response.result_status, _this);
                                            layer.msg(data["response"]["error_msg"]);
                                        }
                                    },
                                    error: function(err) {

                                    }
                                });
                            } else {
                                document.getElementById(file.id).getElementsByTagName('b')[0].innerHTML = info.response;
                            }
                        },
                        Error: function(up, err) {
                            if(err.code == -600) {
                                layer.msg('请选择200mb以内的文件');
                            } else if (err.code == -601) {
                                layer.msg('只允许上传mkv/mp4/avi文件');
                            } else if (err.code == -602) {
                                layer.msg('这个文件已经上传过一遍了');
                            } else {
                                layer.msg(err.response);
                            }
                        }
                    }
                });
                uploader.init();
            },
            // 自定义上传歌曲数据
            getSongsData: function() {
                const _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "type": 2
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "Setting/getCustomSongsList",
                    async: false,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        _this.songData = [];
                        if(data['response']['result_code'] == "true") {
                            $.each(data.response.result, function(k, v) {
                                _this.songData.push({
                                    id: v.song_id,
                                    text: v.song_name,
                                    szSong_code: v.song_code
                                });
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {}
                });
            },
            // 点击选择自定义播放歌曲
            wake_song_fun: function() {
                let _this = this;

                _this.w_song_checkModel = [];
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择自定义播放歌曲', true],
                    area: ['700px', ''], // 宽高
                    content: $(_this.$refs.wakeSong_alert)
                }, function() {
                    if((_this.selSongData.length + _this.w_song_checkModel.length) > 40) {
                        layer.msg("最多选择40首轮播自定义歌曲");
                        return;
                    }

                    _this.songData.forEach(items => {
                        _this.w_song_checkModel.forEach(item => {
                            if(items.id == item) {
                                _this.selSongData.push({
                                    songs_version: "",
                                    szClass: "",
                                    szPlayer: "",
                                    szSong_code: items.szSong_code,
                                    szSong_name: items.text,
                                    szSong_tile: ""
                                });
                            }
                        });
                    });
                    _this.innitSongSelTable();
                    layer.closeAll();
                });
            },
            // 删除自定义播放歌曲
            delSong: function(id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "id": id
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "Setting/delCustomSong",
                    async: true,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            layer.msg(data["response"]["error_msg"]);
                            _this.getSongsData();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取主题歌单
            getThemeSong: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "Setting/getRollingSongsUsableTypeList",
                    async: true,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            _this.theme_song = data.response.result;
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取主题歌单歌曲列表
            getThemeSongList: function() {
                let _this = this;
                if (!_this.songs_type_id) {
                    return;
                }
                // 初始化主题歌单表格
                _this.innitSongThemeTable();
            },
            // 初始化主题歌单表格
            innitSongThemeTable: function() {
                let _this = this;
                $(_this.$refs.songThemeList).bootstrapTable('destroy');
                $(_this.$refs.songThemeList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getThemeSongData(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "szSong_name",
                        title: "歌曲名称",
                        width: "30%"
                    }, {
                        field: "szClass",
                        title: "歌曲分类",
                        width: "25%"
                    }, {
                        field: "szPlayer",
                        title: "歌手",
                        width: "25%"
                    }, {
                        field: "songs_version",
                        title: "版本",
                        width: "20%"
                    }],
                });
            },
            // 获取主题歌单数据
            getThemeSongData: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let name = '',
                    szClass = '',
                    szPlayer = '';
                if(_this.def_field == 'szSong_name') {
                    name = _this.def_con_val;
                } else if(_this.def_field == 'szClass') {
                    szClass = _this.def_con_val;
                } else if(_this.def_field == 'szPlayer') {
                    szPlayer = _this.def_con_val;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "songs_type_id": _this.songs_type_id,
                            "name": name,
                            "szClass": szClass,
                            "szPlayer": szPlayer,
                            "page": pageNumber.toString(),
                            "page_size": params.data.limit.toString()
                        }
                    },
                    "comment": []
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "Setting/getTypeSongsList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.total,
                                rows: data.response.result.rows
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: []
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                        params.success({
                            total: 0,
                            rows: []
                        });
                    }
                });
            },
        }
    }
</script>
<style lang="less">
    .rotation-song-set {
        .rs-list {
            p {
                color: #FF0707;
            }
            table {
                table-layout: fixed;
                word-wrap: break-word;
            }
        }
        .rs-set {
            .rs-usedate {
				position: relative;
				.rs-usedate-everyday {
					label {
						margin: 0 0 10px 9px;
						font-weight: normal;
					}
				}
			}
            .rs-set-def {
                .col-md-5 {
                    border: 1px solid #CCC;
                    margin-left: 15px;
                    table {
                        table-layout: fixed;
                        word-wrap: break-word;
                    }
                }
                h3 {
                    margin-bottom: 20px;
                    text-align: center;
                }
                .def-tit-sel {
                    width: 85px;
                    padding: 0;
                }
                .def-con-val {
                    padding-left: 0;
                    margin-left: -1px;
                }
            }
            .col-md-9 {
                padding: 0;
            }
        }
        .srs-song-alert {
            display: none;
            li {
                display: flex;
                align-items: center;
                margin: 0 0 15px;
                input {
                    margin: 0;
                    cursor: pointer;
                }
                label {
                    word-break: break-all;
                    width: 500px;
                    margin: 0 10px;
                }
                img {
                    height: 29px;
                    cursor: pointer;
                }
            }
        }
    }
</style>